<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="guestExitSurveys" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="guestExitSurveyId" selectionMode="single"
  [(selection)]="guestExitSurvey" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Guest Surveys</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Guest Survey +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Guest Survey +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestExitSurveyId', 'contains')" placeholder="Id"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationId', 'contains')" placeholder="Res #"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'contains')" placeholder="Property"></th>
        <th [ngStyle]="{'width': 'auto'}"><p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'min-width':'120px'}" [options]="constantService.surveyStages" optionLabel="name" optionValue="value" placeholder="Stage" (onChange)="pt.filter($event.value, 'surveyStage', 'in')" appendTo="body"></p-multiSelect></th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-calendar dropdownIcon="fa fa-caret-down" [(ngModel)]="filterReceiveDate" [ngStyle]="{'width':'100%','min-width':'60px'}" [style]="{'min-width':'120px'}" placeholder="Receive Date"
          (onSelect)="onDateFilter($event, 'receiveDate')" (onClearClick)="onDateFilter(null, 'receiveDate')" appendTo="body" [showClear]="true"></p-calendar>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'contains')" placeholder="Title"></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Overall" [(ngModel)]="filterOverallRank" (onChange)="pt.filter($event.value, 'overallExperienceRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Resv" [(ngModel)]="filterReservationistRank" (onChange)="pt.filter($event.value, 'reservationistRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Vehicle" [(ngModel)]="filterVehicleRank" (onChange)="pt.filter($event.value, 'vehicleReservationProcessRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Pre-Arr" [(ngModel)]="filterPreArrivalRank" (onChange)="pt.filter($event.value, 'preArrivalInfoRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Check-in" [(ngModel)]="filterCheckinRank" (onChange)="pt.filter($event.value, 'checkinProcessRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Maint" [(ngModel)]="filterMaintRank" (onChange)="pt.filter($event.value, 'propertyMaintenanceRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'70px'}" [options]="rankFilterOptions" optionLabel="label" optionValue="value" placeholder="Svc" [(ngModel)]="filterSvcRank" (onChange)="pt.filter($event.value, 'guestServicesQualityRank', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'overallExperienceFeedbackDesc', 'contains')" placeholder="Feedback"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestName', 'contains')" placeholder="Name"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestEmail', 'contains')" placeholder="Email"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'100%','min-width':'60px'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestPhone', 'contains')" placeholder="Phone"></th>
        <th [ngStyle]="{'width': 'auto'}"><p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'min-width':'80px'}" [options]="followupRequestFilterOptions" optionLabel="label" optionValue="value" placeholder="Followup" [(ngModel)]="filterFollowupRequest" (onChange)="pt.filter($event.value, 'guestFollowupRequest', 'equals')" appendTo="body"></p-dropdown></th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-calendar [(ngModel)]="filterGuestFollowupDate" [ngStyle]="{'width':'100%','min-width':'60px'}" [style]="{'min-width':'120px'}" placeholder="Followup Date"
          (onSelect)="onDateFilter($event, 'guestFollowupDate')" (onClearClick)="onDateFilter(null, 'guestFollowupDate')" appendTo="body" [showClear]="true"></p-calendar>
        </th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-guestExitSurvey>
    <tr [pSelectableRow]="guestExitSurvey">
      <td>{{guestExitSurvey.guestExitSurveyId}}</td>
      <td class="text-start">
        <div class="d-inline-flex align-items-center gap-1">
          @if (!openingReservation[guestExitSurvey.reservationId]) {
            <span
              (click)="openReservation(guestExitSurvey,$event)"
              class="cursor-pointer link-text">
              {{guestExitSurvey?.reservationId}}
            </span>
          }
          @if (openingReservation[guestExitSurvey.reservationId]) {
            <span>
              <i class="pi pi-spinner pi-spin"></i>
            </span>
          }
        </div>
      </td>
      <td>{{guestExitSurvey.propertyCode}}</td>
      <td>{{ getSurveyStageName(guestExitSurvey.surveyStage) }}</td>
      <td>{{guestExitSurvey.receiveDate | date}}</td>
      <td class="fixdata" [pTooltip]="guestExitSurvey.title" [cancel]="false" tooltipPosition="top">{{ (guestExitSurvey.title || '') | slice:0:20 }}{{ (guestExitSurvey.title?.length || 0) > 20 ? '...' : '' }}</td>
      <td>
        <span>{{ guestExitSurvey?.overallExperienceRank ? (guestExitSurvey.overallExperienceRank + '/5') : '-' }}</span>
      </td>
      <td>
        <span>{{ guestExitSurvey?.reservationistRank ? (guestExitSurvey.reservationistRank + '/5') : '-' }}</span>
      </td>
      <td>
        <span>{{ guestExitSurvey?.vehicleReservationProcessRank ? (guestExitSurvey.vehicleReservationProcessRank + '/5') : '-' }}</span>
      </td>
      <td>
        <span>{{ guestExitSurvey?.preArrivalInfoRank ? (guestExitSurvey.preArrivalInfoRank + '/5') : '-' }}</span>
      </td>
      <td>
        <span>{{ guestExitSurvey?.checkinProcessRank ? (guestExitSurvey.checkinProcessRank + '/5') : '-' }}</span>
      </td>
      <td>
        <span>{{ guestExitSurvey?.propertyMaintenanceRank ? (guestExitSurvey.propertyMaintenanceRank + '/5') : '-' }}</span>
      </td>
      <td>
        <span>{{ guestExitSurvey?.guestServicesQualityRank ? (guestExitSurvey.guestServicesQualityRank + '/5') : '-' }}</span>
      </td>
      <td class="fixdata" [pTooltip]="guestExitSurvey.overallExperienceFeedbackDesc" [cancel]="false" tooltipPosition="top">{{ (guestExitSurvey.overallExperienceFeedbackDesc || '') | slice:0:20 }}{{ (guestExitSurvey.overallExperienceFeedbackDesc?.length || 0) > 20 ? '...' : '' }}</td>
      <td>{{guestExitSurvey.guestName}}</td>
      <td>{{guestExitSurvey.guestEmail}}</td>
      <td>{{guestExitSurvey.guestPhone}}</td>
      <td>{{guestExitSurvey.guestFollowupRequest ? 'Yes' : 'No'}}</td>
      <td>{{guestExitSurvey.guestFollowupDate | date}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(guestExitSurvey)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>